import { render, staticRenderFns } from "./AdminStockItemAlternatives.vue?vue&type=template&id=2d4c0558"
import script from "./AdminStockItemAlternatives.vue?vue&type=script&lang=js"
export * from "./AdminStockItemAlternatives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AdminStockItemAlternatives.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4c0558')) {
      api.createRecord('2d4c0558', component.options)
    } else {
      api.reload('2d4c0558', component.options)
    }
    module.hot.accept("./AdminStockItemAlternatives.vue?vue&type=template&id=2d4c0558", function () {
      api.rerender('2d4c0558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/AdminStockItemAlternatives.vue"
export default component.exports